import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CustomerType } from '@repo/common';

import { CustomerList } from './customer.schema';

// import { SLICE_BASE_NAME } from '../auth/constant';

export interface CustomerState {
  customers: CustomerList['data'];
  pagination: CustomerList['pagination'];
  search: string;
  customer_type: CustomerType;
}

const initialState: CustomerState = {
  customers: [],
  pagination: {} as any,
  search: '',
  customer_type: CustomerType.RETAIL,
};

const customerSlice = createSlice({
  name: `customers`,
  initialState,

  reducers: {
    setCustomerSlice(state, action: PayloadAction<CustomerList>) {
      state.customers = action.payload.data;
      state.pagination = action.payload.pagination;
    },
    setSearch(state, action) {
      state.search = action.payload;
    },
    setCustomerType(state, action) {
      state.customer_type = action.payload;
    },
  },
});

export const { setCustomerSlice, setSearch, setCustomerType } =
  customerSlice.actions;
export default customerSlice.reducer;
